import { http } from './http';
import { api } from './endpoints';
import { DownloadResults } from '@/vue_components/download-overview/useDownloadOverview';

export const downloadsService = {
    getDownloads(letter:string = "", start:number = -1, take:number = 0) {
        return http.get(api.downloads.all(letter, start, take)).then(r => new DownloadResults(r.data));
    },
    getLetters(){
        return http.get(api.downloads.getLetters()).then(r => r.data);
    }
    // searchCountSettings() {
    //     return http.get(api.downloads.searchCountSettings).then(r => r.data);
    // },
};
export type DownloadsService = typeof downloadsService;
